/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line




document.addEventListener('DOMContentLoaded', function() {
  if (document.getElementById('lumi-qty-selector')) {
    // 1. נטרול כל שינוי של ה-ID על ידי התבנית
    const addCardForm = document.querySelector('form[action*="/cart/add"]');
    addCardForm.addEventListener('submit', function() {
       const hiddenIdInput = this.querySelector('input[name="id"]');
       // וידוא שנשלח ה-ID הראשי בלבד ללא הצמדת וריאנט ספציפי
       hiddenIdInput.value = "{{ product.variants.first.id }}";
    });

    // 2. מחיקת הפרמטר מה-URL כדי שהתבנית לא תתבלבל
    const url = new URL(window.location);
    url.searchParams.delete('variant');
    window.history.replaceState({}, '', url);
  }
});


const observer = new MutationObserver(() => {
  const el = document.querySelector('.AirReviews-StarRate--Count');
  if (el) {
    const match = el.textContent.match(/\d+/);
    if (match) {
      el.textContent = `${match[0]} חוות דעת`;
    }
    observer.disconnect();
  }
});

observer.observe(document.body, { childList: true, subtree: true });



  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
